import * as React from "react";

import { cn } from "@/utils/class-name";

function Frame({ className, ...props }: React.ComponentProps<"div">) {
    return (
        <div
            data-slot={"frame"}
            className={cn("relative flex flex-col rounded-2xl bg-muted p-1", className)}
            {...props}
        />
    );
}

function FramePanel({ className, ...props }: React.ComponentProps<"div">) {
    return (
        <div
            data-slot={"frame-panel"}
            className={cn(
                "relative bg-clip-padding not-has-[table]:rounded-xl not-has-[table]:border not-has-[table]:bg-card not-has-[table]:p-5 not-has-[table]:shadow-xs before:pointer-events-none before:absolute before:inset-0 before:rounded-[calc(var(--radius-xl)-1px)] before:shadow-[0_1px_--theme(--color-black/4%)] has-[table]:before:hidden dark:bg-clip-border dark:before:shadow-[0_-1px_--theme(--color-white/8%)]",
                className,
            )}
            {...props}
        />
    );
}

function FrameHeader({ className, ...props }: React.ComponentProps<"header">) {
    return <header data-slot={"frame-panel-header"} className={cn("flex flex-col px-5 py-4", className)} {...props} />;
}

function FrameTitle({ className, ...props }: React.ComponentProps<"div">) {
    return <div data-slot={"frame-panel-title"} className={cn("text-sm font-semibold", className)} {...props} />;
}

function FrameDescription({ className, ...props }: React.ComponentProps<"div">) {
    return (
        <div
            data-slot={"frame-panel-description"}
            className={cn("text-sm text-muted-foreground", className)}
            {...props}
        />
    );
}

function FrameFooter({ className, ...props }: React.ComponentProps<"footer">) {
    return (
        <footer
            data-slot={"frame-panel-footer"}
            className={cn("flex flex-col gap-1 px-5 py-4", className)}
            {...props}
        />
    );
}

export { Frame, FramePanel, FrameHeader, FrameTitle, FrameDescription, FrameFooter };
